(() => {
  class VellaroamPersonalizedTag extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.closest('form');
      this.choice = this.querySelector('[data-vr-tag-opt-in]');
      this.input = this.querySelector('[data-vr-tag-text]');
      this.property = this.querySelector('[data-vr-tag-property]');
      this.error = this.querySelector('[data-vr-tag-error]');
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.choice.addEventListener('change', () => {
        this.sync();
        if (this.choice.checked) this.input.focus({preventScroll:true});
      }, options);
      this.input.addEventListener('input', () => this.sync(), options);
      this.input.addEventListener('blur', () => {this.input.value = this.input.value.trim();this.sync();}, options);
      this.form.addEventListener('submit', event => {
        if (!this.valid()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.error.hidden = false;
          this.input.setAttribute('aria-invalid', 'true');
          this.input.focus();
          this.input.scrollIntoView({behavior:'smooth',block:'center'});
        } else this.sync();
      }, {...options,capture:true});
      this.form.addEventListener('click', event => {
        const express = event.composedPath().some(node => node?.matches?.('shopify-accelerated-checkout,.shopify-payment-button,[data-shopify="payment-button"]'));
        if (express && !this.valid()) {
          event.preventDefault();event.stopImmediatePropagation();
          this.error.hidden = false;this.input.setAttribute('aria-invalid','true');this.input.focus();
        }
      }, {...options,capture:true});
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
        if (String(data.sectionId) === this.dataset.section) this.sync();
      });
      this.sync();
    }
    disconnectedCallback() {this.controller?.abort();this.unsubscribe?.();this.ready = false;}
    valid() {return !this.choice.checked || this.input.value.trim().length > 0;}
    sync() {
      const opted = this.choice.checked;
      const color = this.closest('product-info').querySelector('[data-selected-value]')?.textContent.trim() || 'Black';
      const text = this.input.value.trim();
      this.choice.setAttribute('aria-expanded', String(opted));
      this.querySelector('.vr-tag-details').hidden = !opted;
      this.input.disabled = !opted;
      this.input.required = opted;
      this.property.disabled = !opted || !text;
      this.property.value = opted && text ? `${text} · ${color}` : '';
      this.querySelector('[data-vr-tag-color-label]').textContent = color;
      this.querySelectorAll('[data-vr-tag-color]').forEach(el => {el.hidden = el.dataset.vrTagColor !== color;});
      this.querySelector('[data-vr-tag-count]').textContent = `${this.input.value.length}/12`;
      if (this.valid()) {this.error.hidden = true;this.input.removeAttribute('aria-invalid');}
      this.form.querySelectorAll('.shopify-payment-button,shopify-accelerated-checkout').forEach(el => {
        el.inert = !this.valid();
        el.classList.toggle('vr-tag-needs-text', !this.valid());
      });
    }
  }
  if (!customElements.get('vellaroam-personalized-tag')) customElements.define('vellaroam-personalized-tag', VellaroamPersonalizedTag);
})();
